export const environment = {
  production: true,
  apiHost: "https://api.mediamonorail-dev.com",
  signInUrl: "https://api.mediamonorail-dev.com/authorize",
  connectUrl: "https://mediamonorail-dev.com/assets/connect/v4",
  version: require('../../package.json').version,
  monorailV4URL: "https://v4.mediamonorail-dev.com",
  datadogRumEnv: "sandbox"
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts